/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_zip'
export default icon
